import { Link } from "react-router-dom";
import { Gavel, ArrowRight, Sparkles } from "lucide-react";

export function LandingHero() {
  return (
    <section className="relative overflow-hidden" data-testid="landing-hero">
      <div
        className="absolute inset-0 opacity-[0.5] pointer-events-none"
        style={{
          backgroundImage: "url(https://images.unsplash.com/photo-1637325258040-d2f09636ecf6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)",
          backgroundSize: "cover", backgroundPosition: "center",
          maskImage: "linear-gradient(to bottom, rgba(0,0,0,0.6), transparent 80%)",
          WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,0.6), transparent 80%)",
        }}
      />
      <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 pt-16 sm:pt-24 lg:pt-28 pb-10 grid lg:grid-cols-12 gap-10 lg:gap-8 items-end">
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 animate-fade-up">
            <div className="inline-flex items-center justify-center w-11 h-11 border border-[#D9D4CC] bg-[#FDFBF7] rounded-sm">
              <Gavel className="w-5 h-5 text-[#2C2A29]" strokeWidth={1.5} />
            </div>
            <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-[#7A756E]">War-Zone Global Ministry</p>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2C2A29] leading-[1.08] mt-8 animate-fade-up" style={{ animationDelay: "0.08s" }}>
            Speak the Word.<br />Establish the promise.
          </h1>
          <p className="font-decree text-xl sm:text-2xl text-[#4A4744] mt-7 leading-relaxed max-w-xl animate-fade-up" style={{ animationDelay: "0.16s" }}>
            Type a topic — healing, peace, provision, a child's future — and receive powerful first-person declarations drawn strictly from Scripture, each anchored to its verse.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 animate-fade-up" style={{ animationDelay: "0.24s" }}>
            <Link to="/auth" data-testid="get-started-button"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#2C2A29] text-[#FAF9F6] text-base hover:opacity-90 active:scale-[0.99] transition-all duration-200 rounded-sm">
              Create a free account <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/generate" data-testid="use-as-guest-button"
              className="inline-flex items-center gap-2 px-8 py-4 border border-[#D9D4CC] text-[#2C2A29] text-base hover:bg-[#EAE6DF] transition-colors duration-300 rounded-sm">
              Use as guest
            </Link>
          </div>
          <p className="mt-4 font-body text-sm text-[#7A756E] animate-fade-up" style={{ animationDelay: "0.3s" }}>
            No card needed. Premium comes with a 7-day free trial.
          </p>
        </div>
        <figure className="lg:col-span-5 lg:pb-2 animate-fade-up" style={{ animationDelay: "0.34s" }} data-testid="hero-scripture-quote">
          <blockquote className="border-l-2 border-[#9B7E4E] pl-6 py-2">
            <p className="font-decree italic text-2xl sm:text-3xl text-[#2C2A29] leading-snug">
              “Thou shalt also decree a thing, and it shall be established unto thee: and the light shall shine upon thy ways.”
            </p>
            <figcaption className="font-body text-xs uppercase tracking-[0.2em] text-[#9B7E4E] mt-4 flex items-center gap-2">
              <Sparkles className="w-3.5 h-3.5" /> Job 22:28 · KJV
            </figcaption>
          </blockquote>
        </figure>
      </div>
    </section>
  );
}
